export interface IconConfig {
  [key: string]: string;
}

const iconConfig: IconConfig = {
  exportPng: "/svg/export/png.svg",
  exportPdf: "/svg/export/pdf.svg",
  exportXlsx: "/svg/export/xlsx.svg",
  exportPpt: "/svg/export/ppt.svg",
  exportDownload: "/svg/export/download.svg",
};

export default iconConfig;
